
import React, { useEffect, useState } from 'react';
import styles from '../styles/jupiter.module.css';

const JupiterSwap: React.FC = () => {
  const [initialized, setInitialized] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Give time for the page to fully load
    const timer = setTimeout(() => {
      try {
        // Check if Jupiter is available
        if (!window.Jupiter) {
          console.error('Jupiter not found on window. Make sure CDN script is loaded in HTML head.');
          setError('Jupiter Terminal not available. Please refresh the page.');
          return;
        }

        // Clear any existing Jupiter Terminal instances
        const existingTerminal = document.getElementById('integrated-terminal');
        if (existingTerminal) {
          existingTerminal.innerHTML = '';
        }

        // Initialize Jupiter Terminal
        window.Jupiter.init({
          displayMode: 'integrated',
          integratedTargetId: 'integrated-terminal',
          endpoint: 'https://intensive-delicate-road.solana-mainnet.quiknode.pro/1766608e3638d14189d9863e13ff5d39abf41763/',
          // Important settings for token display
          strictTokenList: false,
          defaultExplorer: 'Solana Explorer',
          formProps: {
            // Do NOT use fixedInputMint or fixedOutputMint here
            initialInputMint: 'So11111111111111111111111111111111111111112', // SOL
            initialOutputMint: 'FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump', // BAKSO
            swapMode: 'ExactIn'
          },
          // This helps with balance updates
          refetchIntervalForTokenAccounts: 5000,
          // Callback when initialization is successful
          onFormUpdate: () => {
            console.log('Jupiter Terminal form updated');
            setInitialized(true);
          },
          // Error handling
          onSwapError: (err: unknown) => {
            console.error('Swap error:', err);
          }
        });

        console.log('Jupiter Terminal initialized');
      } catch (err) {
        console.error('Error initializing Jupiter Terminal:', err);
        setError(`Error: ${err instanceof Error ? err.message : String(err)}`);
      }
    }, 1000); // Wait 1 second for everything to load

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles.swapContainer}>
      <h2>Swap for $BAKSO</h2>
      <div className={styles.tigerDivider}></div>
      <p>Use the widget below to easily swap SOL for $BAKSO tokens!</p>
  
      {error && (
        <div className={styles.errorBox}>
          <p>{error}</p>
          <button
            className={styles.refreshButton}
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
        </div>
      )}
  
      <div id="integrated-terminal" className={styles.terminalContainer}></div>
    </div>
  );
};

// Add type definition for window
declare global {
  interface Window {
    Jupiter?: {
      init: (config: any) => void;
      syncProps?: (config: any) => void;
    };
  }
}

export default JupiterSwap;